import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../App/actions'
import styles from './ReportsPage.scss'
import appStyles from '../App/appStyles.scss'
import cx from 'classnames'
import { Navbar, NavbarGroup, NavbarTitle } from 'common/Navbar'
import { Icon } from 'common/LegacyIcon'
import { Link, Route } from 'react-router'
import { ShowPageContainer } from './ShowPage'
import { EditPageContainer } from './EditPage'

export class ReportsPage extends React.Component {
  componentDidMount () {
    const { params: { id, userId }, loadReportsPage, loadUserReportsPage } = this.props
    if (userId) {
      loadUserReportsPage(userId)
    } else if (id) {
      loadReportsPage(id)
    }
  }

  render () {
    const { children, reportsPage, currentUser } = this.props
    const canEdit = reportsPage.user && currentUser.id === reportsPage.user.id
    return (
      <div className={cx(styles.ReportsPage, appStyles.base)}>
        <Navbar>
          <NavbarGroup>
            <li><NavbarTitle to='/ride_reports'>Ride Reports</NavbarTitle></li>
          </NavbarGroup>
          <NavbarGroup />
          {canEdit && <NavbarGroup>
            <li><Link to='/ride_reports/new'><Icon i='circlePlus' size={15} /> new report</Link></li>
          </NavbarGroup>}
        </Navbar>
        {children}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  reportsPage: state.reportsPage,
  currentUser: state.currentUser
})

const mapDispatchToProps = (dispatch) => ({
  loadReportsPage: id => dispatch(actions.loadReportsPage(id)),
  loadUserReportsPage: userId => dispatch(actions.loadUserReportsPage(userId))
})

export const ReportsPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsPage)

export const routes = (
  <Route component={ReportsPageContainer}>
    <Route path='/users/:userId/reports_page' component={ShowPageContainer} />
    <Route path=':id' component={ShowPageContainer} />
    <Route path=':id/edit' component={EditPageContainer} />
  </Route>
)
